import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import useTestStore from '../../stores/testStore';

import "./TestVariationDetails.css";

import React, { useState } from 'react';

import moment from 'moment';


// storage
import { storage } from '../../firebase';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"
import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from '../../firebase';

export default function TestVariationDetails() {
    const testDoc = useTestStore(state => state.testDoc);
    const setTestDoc = useTestStore(state => state.setTestDoc);

    const [editingIndex, setEditingIndex] = useState(null);

    const [percentage, setPercentage] = useState(0);
    const [file, setFile] = useState("");
    const [url1, setUrl1] = useState("");

    const handleChange = (event) => {
        console.log('event.target.id', event.target.id);
        const tempTitles = testDoc.titles;
        tempTitles[event.target.id] = event.target.value;
        setTestDoc({
            ...testDoc,
            titles: tempTitles
        });
    };


    const handleEdit = async (event, file, index) => {
        // Prevent default behavior (Prevent page from refreshing)
        event.preventDefault();
        console.log('handleEdit', file, index);
        if (!file) {
            alert("Please choose a file first!")
        }
        // Get today's month
        // const reference = ref(storage, "tests/");

        // Resize image
        // const resizedImage = await resizeImage(file);
        // console.log('resizedImage', resizedImage);

        const storageRef = ref(storage, `/postTests/${moment().format('YYYY')}/${moment().format('MMMM')}/${testDoc.testTitle}/${index}`)

        // const uploadTask = await uploadString(storageRef, resizedImage, "data_url");


        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on("state_changed",
            (snapshot) => {
                const progress =
                    Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                console.log("Upload is " + progress + "% done");
                setPercentage(progress);
            },
            (error) => {
                alert(error);
            },
            () => {
                getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
                    // Set to firestore database
                    console.log('downloadURL', downloadURL);
                    console.log('testDoc.testId', testDoc.postId);
                    const q = doc(db, "postTests", testDoc.postId);

                    // Generate new thumbnail array
                    const newThumbnailArray = testDoc.thumbnails;
                    newThumbnailArray[index] = downloadURL;

                    try {

                        let Qsnapshot = await updateDoc(q, {
                            updatedTime: serverTimestamp(),
                            // Make thumbnail array with index index equal to downloadURL, but keep the rest of the array the same
                            'thumbnails': newThumbnailArray
                        }).then(() => {
                            // setUpdatedProfile(true)
                            console.log('Test Edited!');
                            alert(
                                'Edit Saved!',
                            );
                            // Refresh page
                            window.location.reload();
                        })
                    }
                    catch (error) {
                        alert(error);
                    }

                });
            }
        );
    }


    return (
        <>
            <div style={{ marginTop: '20px' }} />
            <h2>Test Variation Details</h2>
            <div style={{ marginTop: '20px' }} />

            <div className="variation-container">
                <div className="title-group">
                    {testDoc.titles.map((title, index) => (
                        <div className="title-item" key={`title-${index}`}>
                            <TextField
                                fullWidth
                                id={`${index}`}
                                label={`Title ${index}`}
                                value={title ?? ''}
                                onChange={handleChange}
                                variant="outlined"
                            />
                        </div>
                    ))}
                </div>

                <div className="thumbnail-group">
                    {testDoc.thumbnails.map((thumbnail, index) => (
                        <div className="thumbnail-item" key={`thumbnail-${index}`}>
                            <div className="thumbnail-preview-frame">
                                <img src={thumbnail} alt={`Thumbnail ${index}`} loading="lazy" />
                            </div>
                            <div className="thumbnail-header">
                                <span>{`Thumbnail ${index}`}</span>
                                {editingIndex !== index && (
                                    <Button
                                        variant="contained"
                                        className="edit-btn"
                                        onClick={() => setEditingIndex(index)}
                                    >
                                        Edit
                                    </Button>
                                )}
                            </div>
                            {editingIndex === index && (
                                <div className="upload-controls">
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(event) => setFile(event.target.files[0])}
                                    />
                                    <button
                                        className="upload-btn"
                                        onClick={(event) => handleEdit(event, file, index)}
                                    >
                                        Upload
                                    </button>
                                    {url1 && <img src={url1} alt="uploaded preview" />}
                                    <p className="progress-text">Upload Progress: {percentage}%</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
